'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _type = require('./type');

var _type2 = _interopRequireDefault(_type);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

var _dofIconfont = require('../dof-iconfont');

var _dofIconfont2 = _interopRequireDefault(_dofIconfont);

var _style = require('./style');

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  components: { DofIconfont: _dofIconfont2.default },
  props: {
    //type value  info, warning, danger,  新增warning-i18n, 'important（colmo）'
    type: {
      type: String,
      default: 'info'
    },
    notice: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: ''
    },
    btnText: {
      type: String,
      default: ''
    },
    //  0.1.14新需求
    center: {
      type: Boolean,
      default: false
    },
    //  0.1.20新需求, 提醒内容两行以上
    lines: {
      type: [Number, String],
      default: 2
    }
  },

  computed: {
    themeStyle: function themeStyle() {
      var _theme = this._theme || 'default';
      return _style.STYLE_MAP[_theme] || _style.STYLE_MAP['default'];
    },
    colmoIconColor: function colmoIconColor() {
      var map = {
        info: '#B35336',
        important: 'rgba(255,255,255,0.80)'
      };
      return map[this.type];
    },
    activeBtnText: function activeBtnText() {
      if (this._isColmo && this.type == 'info') {
        return 'colmobtn-active-info';
      } else if (this._isColmo && this.type == 'important') {
        return 'colmobtn-active-important';
      }
      return '';
    },
    noticebarStyle: function noticebarStyle() {
      var style = {};
      var mode = this.mode;

      switch (this.type) {
        case 'warning':
          style = {
            backgroundColor: this._isDiablo ? '#211E15' : '#FFF6E7'
          };
          break;
        case 'warning-i18n':
          style = {
            backgroundColor: 'rgba(245,100,40,0.1)'
          };
          break;
        case 'danger':
          style = {
            backgroundColor: this._isDiablo ? '#db5c44' : '#FFEBEA'
          };
          break;
        case 'important':
          style = {
            backgroundColor: '#B35336'
          };
          break;
        default:
          style = {};
      }
      if (mode == 'btn' || mode == 'all') {
        style = _extends({}, style, {
          paddingTop: '12px',
          paddingBottom: '12px'
        });
      }
      return style;
    },
    contentStyle: function contentStyle() {
      var style = {};
      switch (this.type) {
        case 'warning':
          style = {
            color: '#E09916'
          };
          break;
        case 'warning-i18n':
          style = {
            color: '#F56428'
          };
          break;
        case 'danger':
          style = {
            color: '#F56428'
          };
          break;
        case 'important':
          style = {
            color: 'rgba(255,255,255,0.80)'
          };
          break;
        default:
          style = {};
      }
      style = _extends({
        lines: this.lines
      }, style);
      return style;
    },
    btnTextStyle: function btnTextStyle() {
      var style = {};
      switch (this.type) {
        case 'warning':
          style = {
            color: '#E09916',
            // 'borderColor':'E09916'   // 无效
            //  borderLeftColor: '#E09916', 应设计师新需求，调整透明度
            borderLeftColor: '#E09916',
            borderRightColor: '#E09916',
            borderTopColor: '#E09916',
            borderBottomColor: '#E09916'
          };
          break;
        case 'warning-i18n':
          style = {
            color: '#F56428',
            // 'borderColor':'E09916'   // 无效
            //  borderLeftColor: '#E09916', 应设计师新需求，调整透明度
            borderLeftColor: '#F56428',
            borderRightColor: '#F56428',
            borderTopColor: '#F56428',
            borderBottomColor: '#F56428'
          };
          break;
        case 'danger':
          style = {
            color: '#F56428',
            // borderLeftColor: '#F56428',应设计师新需求，调整透明度
            borderLeftColor: 'rgba(255,59,48, 0.5)',
            borderRightColor: 'rgba(255,59,48, 0.5)',
            borderTopColor: 'rgba(255,59,48, 0.5)',
            borderBottomColor: 'rgba(255,59,48, 0.5)'
          };
          break;
        case 'important':
          style = {
            color: 'rgba(255,255,255,0.8)',
            borderLeftColor: 'rgba(255,255,255,0.8)',
            borderRightColor: 'rgba(255,255,255,0.8)',
            borderTopColor: 'rgba(255,255,255,0.8)',
            borderBottomColor: 'rgba(255,255,255,0.8)'
          };
          break;
        default:
          style = {};
      }

      if (this.mode == 'all') {
        style = _extends({
          marginRight: this.themeStyle.modeAllWidth,
          marginLeft: this.themeStyle.modeAllLeft
        }, style);
      }
      return style;
    },
    typeIcon: function typeIcon() {
      var typeIcon = void 0;
      //type info, warning, danger,  warning-i18n
      switch (this.type) {
        case 'warning':
          typeIcon = this._isDiablo ? _type2.default.warnIconDiablo : _type2.default.warnIcon;
          break;
        case 'warning-i18n':
          typeIcon = _type2.default.warnI18nIcon;
          break;
        case 'danger':
          typeIcon = _type2.default.dangerIcon;
          break;
        case 'important':
          typeIcon = _type2.default.colmoImportantIcon;
          break;
        default:
          typeIcon = this._theme == 'colmo' ? _type2.default.colmoInfoIcon : _type2.default.infoIcon;
      }
      return typeIcon;
    },
    modeIcon: function modeIcon() {
      var modeIcon = void 0;
      switch (this.type) {
        case 'warning':
          modeIcon = this._isDiablo ? _type2.default.warnCloseIconDiablo : _type2.default.warnCloseIcon;
          break;
        case 'warning-i18n':
          modeIcon = _type2.default.warnI18nCloseIcon;
          break;
        case 'danger':
          modeIcon = _type2.default.dangerCloseIcon;
          break;
        default:
          modeIcon = _type2.default.infoCloseIcon;
      }
      return modeIcon;
    },
    linkIcon: function linkIcon() {
      var linkIcon = void 0;
      switch (this.type) {
        case 'warning':
          linkIcon = _type2.default.warnLink;
          break;
        case 'warning-i18n':
          linkIcon = _type2.default.warnI18nLink;
          break;
        case 'danger':
          linkIcon = _type2.default.dangerLink;
          break;
        default:
          linkIcon = _type2.default.infoLink;
      }
      return linkIcon;
    }
  },
  data: function data() {
    return {
      show: true
    };
  },
  methods: {
    // noticebar click
    noticeBarClicked: function noticeBarClicked() {
      // console.log('dofNoticebarClicked');
      this.$emit('dofNoticebarClicked', {});
    },


    // notice icon click
    noticeIconClicked: function noticeIconClicked() {
      var mode = this.mode;

      this.$emit('dofNoticebarBtnClicked', {}); //button clicked
    },
    closeIconClicked: function closeIconClicked() {
      this.show = false;
      this.$emit('dofNoticebarCloseClicked', {}); //close clicked
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-noticebar/index.vue
// module id = 351
// module chunks = 0 1